import React from 'react';
import { NotificationPreferences } from '../../../../../../../__generated__/loma';
import { LayoutTree } from '../../../DynamicLayout';
import { Channels } from '../../types';
import SmsOptIn from './SMS';
import EmailOptIn from './Email';
import LineOptIn from './Line';
import { ERROR_TYPES } from '../..';

export interface OptInProps {
  onOptIn: (
    contactInfo: string,
    retailerLevel: boolean,
    marketingOptInChecked?: boolean,
    savePreferencesChecked?: boolean,
  ) => void;
  onChange: () => void;
  featureName?: string;
  layout?: LayoutTree.FeatureLayout;
  channel: Channels;
  validationError?: ERROR_TYPES;
  notificationPreferencesState?: NotificationPreferences;
  consumerPreferencesOptinEnabled?: boolean;
  retailerMarketingOptinEnabled?: boolean;
}

const OptIn = ({
  featureName,
  layout,
  onOptIn,
  onChange,
  channel,
  validationError,
  notificationPreferencesState,
  consumerPreferencesOptinEnabled,
  retailerMarketingOptinEnabled,
}: OptInProps) => {
  switch (channel) {
    case Channels.SMS:
    case Channels.HIPAA_SMS:
      return (
        <SmsOptIn
          featureName={featureName}
          layout={layout}
          onOptIn={onOptIn}
          onChange={onChange}
          channel={channel}
          validationError={validationError}
          notificationPreferencesState={notificationPreferencesState}
          consumerPreferencesOptinEnabled={consumerPreferencesOptinEnabled}
          retailerMarketingOptinEnabled={retailerMarketingOptinEnabled}
        />
      );
    case Channels.EMAIL:
    case Channels.HIPAA_EMAIL:
      return (
        <EmailOptIn
          featureName={featureName}
          layout={layout}
          onOptIn={onOptIn}
          channel={channel}
          validationError={validationError !== undefined}
          notificationPreferencesState={notificationPreferencesState}
        />
      );
    case Channels.LINE:
      return (
        <LineOptIn
          featureName={featureName}
          layout={layout}
          channel={channel}
          notificationPreferencesState={notificationPreferencesState}
        />
      );
    default:
      // TODO: Log an error?
      return null;
  }
};

export default OptIn;
